<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { BIReport } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import BIReportForm from '@/components/power-bi/BIReportForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const props = defineProps<{
        biReport: BIReport;
    }>();

    const form = useForm({
        company_id: selectedCompanyId.value,
        bi_id: props.biReport.id,
        reporting_account: props.biReport.reporting_account,
        reporting_account_nr: props.biReport.reporting_account_nr,
        account_mapping: props.biReport.accounts_in_mapping,
        measurement_calculation: props.biReport.measurement_calculation,
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.powerbi.setup.store')"
        method="post"
        :query-key="[QueryKey.POWER_BI, selectedCompanyId]"
        title="bi_and_companies.edit_bi_row"
    >
        <BIReportForm :form="form" />
    </DialogForm>
</template>
